import React from "react";
import {
  Row,
  Col,
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  UncontrolledTooltip,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { RenderSingleSelect } from "../../components";
import { Field } from "formik";
import { showTooltip } from "../../actions";

import {
  views_engage_range_left,
  views_engage_range_right,
} from "../../helpers/Views";
const ViewsFilter = (props) => {
  const { t } = useTranslation();

  const from_options = () => {
    return views_engage_range_left.map((option) => {
      if (
        props.state.viewsTo &&
        props.state.viewsTo.value &&
        props.state.viewsTo.value <= option.value
      ) {
        return { ...option, isDisabled: true };
      } else {
        return { ...option, isDisabled: false };
      }
    });
  };

  const to_options = () => {
    return views_engage_range_right.map((option) => {
      if (
        props.state.viewsFrom &&
        props.state.viewsFrom.value &&
        props.state.viewsFrom.value >= option.value
      ) {
        return { ...option, isDisabled: true };
      } else {
        return { ...option, isDisabled: false };
      }
    });
  };
  return (
    <ButtonDropdown
      className="col-12 col-sm-6 col-md-4 col-lg-2 second"
      isOpen={props.state.filters.views}
      toggle={() => props.toggleFilter("views")}
    >
      <DropdownToggle caret className="btn btn-default btn-dropdown-white">
        {t("discovery.filters.views.title")}
      </DropdownToggle>
      <DropdownMenu className="ddmenu-col custom-dropdown-column width-md">
        <Row>
          <Col md="12" className="col">
            <span className="tooltip-button-wrap">
              <span className="text-tooltip">
                <h3 className="head icon-influencer">
                  {t("discovery.influencer")}
                </h3>
              </span>
              <span id="viewsRate" className="tooltip-icon tool-top"></span>
            </span>
            <UncontrolledTooltip className="tooltip-content" target="viewsRate">
              {showTooltip("viewsRate")}
            </UncontrolledTooltip>
            <FormGroup className="select-field-col follower-col">
              <Field
                component={RenderSingleSelect}
                name="viewsFrom"
                placeholder={t("discovery.fields.from")}
                value={props.state.viewsFrom}
                onChange={(input) =>
                  props.handleSingleSelectChange(input, "viewsFrom")
                }
                options={from_options()}
              />
            </FormGroup>

            <FormGroup className="select-field-col last">
              <Field
                component={RenderSingleSelect}
                name="viewsTo"
                placeholder={t("discovery.fields.to")}
                value={props.state.viewsTo}
                onChange={(input) =>
                  props.handleSingleSelectChange(input, "viewsTo")
                }
                options={to_options()}
              />
            </FormGroup>
          </Col>
        </Row>
      </DropdownMenu>
    </ButtonDropdown>
  );
};
export default ViewsFilter;
